module.exports = __webpack_public_path__ + "static/media/CT_2019_30460.24073c76.png";